'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import ProdutoPaginaDesktopFallback from '../Designs/Desktop/fallback';
import ProdutoPaginaMobileFallback from '../Designs/Mobile/fallback';

export default function ProdutoPaginaFallback() {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <ProdutoPaginaMobileFallback />
  ) : (
    <ProdutoPaginaDesktopFallback />
  );
}
